export default "__VITE_ASSET__EqmcB4MZ__"